import { EParcelType } from "dto/EParcelType";
import { ItemKind } from "dto/IKindItems";
import { IParcelTypes } from "dto/IParcelTypes";

export const translateToPolish = (parcelType: IParcelTypes) => {
  switch (parcelType) {
    case IParcelTypes.EDelivery:
      return "e-doręczenie";
    case IParcelTypes.Email:
      return "e-mail";
    case IParcelTypes.EncryptedEDelivery:
      return "e-doręczenie";
    case IParcelTypes.ExternalEDelivery:
      return "e-doręczenie (urzędowe)";
    case IParcelTypes.Puh:
      return "e-Doręczenia hybrydowe (PUH)";
    case IParcelTypes.Epuap:
      return "ePUAP";
    case IParcelTypes.NotaEncrypted:
      return "przesyłka szyfrowana";
    case IParcelTypes.TraditionalLetter:
      return "papierowa";
    case IParcelTypes.CourtPortalWriting:
      return "portal informacyjny";
  }
};

export const convertParcelTypeToKind = (parcel: IParcelTypes) => {
  switch (parcel) {
    case IParcelTypes.EDelivery:
      return EParcelType.EDelivery;
    case IParcelTypes.Email:
      return EParcelType.Email;
    case IParcelTypes.EncryptedEDelivery:
      return EParcelType.EDelivery;
    case IParcelTypes.ExternalEDelivery:
      return EParcelType.ExternalEDelivery;
    case IParcelTypes.Puh:
      return EParcelType.Puh;
    case IParcelTypes.Epuap:
      return EParcelType.Epuap;
    case IParcelTypes.NotaEncrypted:
      return EParcelType.NotaEncrypted;
    case IParcelTypes.TraditionalLetter:
      return EParcelType.TraditionalLetter;
    case IParcelTypes.CourtPortalWriting:
      return EParcelType.TraditionalLetter;
    case IParcelTypes.ContactMessage:
      return EParcelType.ContactMessage;
  }
};

export const convertEParcelTypeToIParcelType = (parcel: EParcelType) => {
  console.log("convertEParcelTypeToIParcelType", parcel);
  switch (parcel) {
    case EParcelType.EDelivery:
      return IParcelTypes.EDelivery;
    case EParcelType.Email:
      return IParcelTypes.Email;
    case EParcelType.EncryptedEDelivery:
      return IParcelTypes.EDelivery;
    case EParcelType.ExternalEDelivery:
      return IParcelTypes.ExternalEDelivery;
    case EParcelType.Puh:
      return IParcelTypes.Puh;
    case EParcelType.Epuap:
      return IParcelTypes.Epuap;
    case EParcelType.NotaEncrypted:
      return IParcelTypes.NotaEncrypted;
    case EParcelType.TraditionalLetter:
      return IParcelTypes.TraditionalLetter;
    case EParcelType.CourtPortalWriting:
      return IParcelTypes.CourtPortalWriting;
  }

  return null;
};

export const getTypeOfParcel = (itemKind: number) => {
  const types: IParcelTypes[] = [];

  if (itemKind & EParcelType.TraditionalLetter) {
    types.push(IParcelTypes.TraditionalLetter);
  }
  if (itemKind & EParcelType.Email) {
    types.push(IParcelTypes.Email);
  }
  if (itemKind & EParcelType.NotaEncrypted) {
    types.push(IParcelTypes.NotaEncrypted);
  }
  if (itemKind & EParcelType.EncryptedEDelivery) {
    types.push(IParcelTypes.EncryptedEDelivery);
  } else if (itemKind & EParcelType.EDelivery) {
    types.push(IParcelTypes.EDelivery);
  }

  if (itemKind & EParcelType.ExternalEDelivery) {
    types.push(IParcelTypes.ExternalEDelivery);
  }

  if (itemKind & EParcelType.Puh) {
    types.push(IParcelTypes.Puh);
  }

  if (itemKind & EParcelType.Epuap) {
    types.push(IParcelTypes.Epuap);
  }

  if (itemKind & EParcelType.CourtPortalWriting) {
    types.push(IParcelTypes.CourtPortalWriting);
  }

  return types;
};

export const getTypeOfParcelFromKind = (itemKind: number) => {
  const types: IParcelTypes[] = [];
  let toRet = itemKind;

  if (toRet >= ItemKind.Email) {
    types.push(IParcelTypes.Email);
    toRet -= ItemKind.Email;
  }

  if (toRet >= ItemKind.Parcel) {
    toRet -= ItemKind.Parcel;
    types.push(IParcelTypes.Parcel);
  }

  if (toRet >= ItemKind.CourtPortalDeliverance) {
    toRet -= ItemKind.CourtPortalDeliverance;
    types.push(IParcelTypes.CourtPortalDeliverance);
  }

  if (toRet >= ItemKind.CourtPortalDocument) {
    toRet -= ItemKind.CourtPortalDocument;
    types.push(IParcelTypes.CourtPortalDocument);
  }

  if (toRet >= ItemKind.EDeliveryMessage) {
    toRet -= ItemKind.EDeliveryMessage;
    types.push(IParcelTypes.EDeliveryMessage);
  }

  if (toRet >= ItemKind.CourtPortalApplication) {
    types.push(IParcelTypes.CourtPortalApplication);
    toRet -= ItemKind.CourtPortalApplication;
  }
  if (toRet >= ItemKind.ContactMessage) {
    types.push(IParcelTypes.ContactMessage);
    toRet -= ItemKind.ContactMessage;
  }
  if (toRet >= ItemKind.OutgoingParcel) {
    types.push(IParcelTypes.OutgoingParcel);
    toRet -= ItemKind.OutgoingParcel;
  }

  return types;
};
